module.exports = __webpack_public_path__ + "img/stock-m2.4fea444d.png";